export default "__VITE_ASSET__B9ls50mx__"